import { AppDataTable } from '@root/features/app-data-table/app-data-table'

import type {
  TopTradersTableColumnId,
  TopTradersTableContext,
} from '../atoms/reatom-top-traders-column-id'
import type { Maker } from '@root/entities/trade'
import type { ClassNameProps } from '@root/shared/react'
import type { DataTableModel } from '@root/shared/ui-kit'

type Props = {
  context: TopTradersTableContext
  tableModel: DataTableModel<
    Maker.RankedMaker,
    TopTradersTableColumnId,
    object,
    TopTradersTableContext
  >
} & ClassNameProps

export const TopTradersTable: React.FC<Props> = ({
  className,
  tableModel,
  context,
}) => {
  return (
    <AppDataTable
      className={className}
      model={tableModel}
      rowHeight={40}
      context={context}
    />
  )
}
